import type { TransactionDetailsView } from '@mentora/api-public'
import type { CancelMembershipAction } from './membership-actions-card'
import type { RetryRefundAction } from './retry-refund-button'
import type { TransactionActions } from './transaction-actions-card'
import { callApi } from '../api-client'

// The Platform Admin's transaction endpoints on apps/api (every call to a
// payment provider runs there), reached through the web app's
// `/api/transactions/*` rewrite.

type Kind = 'course' | 'event' | 'membership'

const BASE = '/api/transactions'
const NETWORK = 'transactions.actions.errors.network'

export interface TransactionsApi extends TransactionActions {
  load: (input: { kind: Kind, id: string }) => ReturnType<typeof callApi<TransactionDetailsView>>
  cancelMembership: CancelMembershipAction
  retryRefund: RetryRefundAction
}

export const transactionsApi: TransactionsApi = {
  load: ({ kind, id }) => callApi<TransactionDetailsView>(`${BASE}/details?${new URLSearchParams({ kind, id })}`, { method: 'GET' }, 'transactions.dialog.loadFailed'),
  refund: input => callApi(`${BASE}/refund`, { method: 'POST', body: input }, NETWORK),
  cancel: input => callApi(`${BASE}/cancel`, { method: 'POST', body: input }, NETWORK),
  retryRefund: input => callApi(`${BASE}/refunds/retry`, { method: 'POST', body: input }, NETWORK),
  cancelMembership: input => callApi(`${BASE}/membership/cancel`, { method: 'POST', body: input }, NETWORK),
}
